import React from 'react';
import CountUp from 'react-countup';

function Card({ image, name, count, modifier }) {
  return (
    <div className={`cardComponent cardComponent--${modifier}`}>
      <div className="card-icon-wrap">
        <img className="card-img" src={image} alt={`${name} icon`} />
      </div>
      <div className="card-body-content">
        {count !== undefined && (
          <CountUp
            start={0}
            end={count}
            duration={2.5}
            className="card-count"
          />
        )}
        <p className="card-label">{name}</p>
      </div>
    </div>
  );
}

export default Card;